import React, { useState, FormEvent, useEffect, DependencyList } from 'react';

import { useParams } from 'react-router-dom';

import { Suggest, ItemRenderer, ItemPredicate } from '@blueprintjs/select';
import { FormGroup, InputGroup,  Button, Tabs, Tab, Collapse, HTMLSelect, HTMLTable, ControlGroup, NumericInput, TextArea, Position, Toaster, Intent, MenuItem } from "@blueprintjs/core";
import { Radio, RadioGroup, Switch, ProgressBar ,AnchorButton,Dialog, DialogBody,Callout} from "@blueprintjs/core";
import { Classes, Card, Elevation } from "@blueprintjs/core";
import { IconNames } from "@blueprintjs/icons";

import { AxiosInstance } from 'axios';

import { H2, H3, H4, H5, H6 } from "@blueprintjs/core";
import * as utils from "./utils";

import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import svgWait1 from './svg/wait1.svg'
import svgWait2 from './svg/wait2.gif'

import i18next from 'i18next';
import { CCASSRptINFO,departmentINFO} from './Types'
import { SystemHeader } from './CommonUI';

//import CryptoJS from "crypto-js";
import { BUTTON } from '@blueprintjs/core/lib/esm/common/classes';
import { Container } from 'konva/lib/Container';
import DviewOutMain from './DviewOut';
//import FloatingButton from './FloatingButton';
import { POINT_CONVERSION_UNCOMPRESSED } from 'constants';

 
import CCassAddDeptMain from './CCassAddDept';
interface RptRstInfo {
    Rst_Key: string,
    Rst_Line: string,
}

interface PageInfo {
    n: number
}

var GsbFlag: any;


interface CCASSRptMainProps {
    gsb: AxiosInstance
  
}


const toaster = Toaster.create({
    position: Position.TOP,
})

 
interface DviewInfo {
    reportId : string,
    filename :string, 
    reportName :string, 
    times:string,
    cFNExt:string,
    StatementType :string,
    PathName: string,
    size: number,
    date: string,
    time: string,  
    isChecked:boolean,
}


function CCASSRptMain({ gsb }: CCASSRptMainProps) {

    let ProgressId2 = ""

    const { register,  reset, setValue, setError, errors } = useForm<CCASSRptINFO>()

    const imgWait = <img className="WaitIcon" src={svgWait2} alt="wait" />
    const coLogo = <img className="coLogo" src="coLogo.gif" alt="Co Logo" />    
    const { t, i18n } = useTranslation();
    const [ProgressId, setProgressId] = useState("")
    const [ProgressValue, setProgressValue] = useState(0)
    const [Rstdata, setRstdata] = useState([] as RptRstInfo[])
    const [Rstdata2, setRstdata2] = useState([] as RptRstInfo[])
    const [RptHead1, setRptHead1] = useState("")
    const [RptName, setRptName] = useState("")
    const [logName, setlogName] = useState("")
    const [RptNameNo, setRptNameNo] = useState(0)   
    const [ErrCount, setErrCount] = useState(0)   
     
    const [aRptNameNo, setaRptNameNo] = useState([] as PageInfo[]) 
    const [ShowRpt, setShowRpt] = useState(false)
    const [ShowNoRecord, setShowNoRecord] = useState(false)
    const [ShowOK, setShowOK] = useState(true)
    const [s_Lang, sets_Lang] = useState("Chi_ZH")
    const [DataFormatValue, setDataFormatValue] = useState(false)
    const [CSVFormat, setCSVFormat] = useState("0")
    const [nPage, setnPage] = useState(0)
    const [nTotalPage, setnTotalPage] = useState(0)
    const [aPageNumber, setaPageNumber] = useState([] as PageInfo[])
    const [MoblieDev, setMoblieDev] = useState(false)
    const [ShowWait, setShowWait] = useState(false)
    const [searchLimit, setSearchLimit] = useState(20)
    const [searchBackward, setSearchBackward] = useState(false)
    const [selectedTabId, setSelectedTabId] = useState("list")   
    //const [cPrintMode, setcPrintMode] = useState("PS") 
    const [CO_NAME, setCO_NAME] = useState("")
    const [companyLogoName, setcompanyLogoName] = useState("")
    const [SBPath, setSBPath] = useState("")
    const [TRAN_DATE, setTRAN_DATE] = useState(utils.formatNumber(new Date()))
    const [SETL_DATE, setSETL_DATE] = useState(utils.formatNumber(new Date()))
    const [cardOpen01, setcardOpen01] = useState("cardOpen01-Theme0")
    const [Enter2tab, setEnter2tab] = useState("Y")
    const [SUSPEND_AC, setSUSPEND_AC] = useState(false) 
    const [s_Date1, sets_Date1] = useState(utils.formatNumber(new Date()))
    const [s_Date2, sets_Date2] = useState(utils.formatNumber(new Date()))
    const [s_AcStatus, sets_AcStatus] = useState("A") 

    const [ countnumber,setcountnumber] = useState(0) 

    const [ countnumberData2,setcountnumberData2] = useState(0) 
    
    const [ count ,setcount] =useState(0)
 
    const [s_reportID, sets_reportID] = useState("")
     
    const [s_MTKCode, sets_MTKCode] = useState("ALL")

   // const [CountryList, setCountryList] = useState([] as CountryINFO[]) 

    const [CCASSRptDesc,setCCASSRptDesc ] = useState("")
    const [CCASSRptList, setCCASSRptList] = useState([] as CCASSRptINFO[])
     
    const [DviewInfoList, setDviewInfoList] = useState([] as DviewInfo[])
    const [VarInfoList, setVarInfoList] = useState([] as DviewInfo[])
   
    //departmentINFO
    const [departmentInfoList,setdepartmentInfoList] = useState ([] as departmentINFO[])
    const [s_DepartmentName,sets_DepartmentName] = useState("Default")
    //float

 /*
    const buttonStyle = (topValue: number): React.CSSProperties => ({
        position: 'fixed',
        top: topValue,
        right: '50px', // Adjust as needed for horizontal position
        zIndex: 1000, // Ensure it's above other content
        // Add other styling for your button (background, padding, border-radius, etc.)
        //backgroundColor: '#BCD1E9',
        
        padding: '10px 15px',
        borderRadius: '5px',
        cursor: 'pointer',
        border: 'none',
    });
*/

    const [items, setItems] = useState<DviewInfo[]>(DviewInfoList);
    const [RptLogName, setRptLogName] = useState("")

    const handleCheckboxChange = (PathName: string) => {
      setDviewInfoList((prevItems) =>
        prevItems.map((item) =>
          item.PathName === PathName ? { ...item, isChecked: !item.isChecked } : item
        )
      );
    }
    const hangedHandler = (e : React.ChangeEvent<HTMLInputElement>) =>
    {
        var i = 0;
        const { name, checked}= e.target;
        //console.log(name);
//  const checkedvalue= userData.map( (user)=>user.username ===name? {...user, isChecked:checked}:user);
        if(name==="allselect")
        {
            const checkedvalue = DviewInfoList.map( (prevItems)=>{ return {...prevItems, isChecked:checked}});              
           // console.log(checkedvalue);
            setDviewInfoList(checkedvalue);
        }
        else {
            const checkedvalue= DviewInfoList.map( (prevItems)=>prevItems.PathName ===name? {...prevItems, isChecked:checked}:prevItems);
           // console.log(name);
           // console.log(checkedvalue);
            setDviewInfoList(checkedvalue);
            /*
            for(let i=0; i<DviewInfoList.length; i++)
            {
              if(DviewInfoList[i].isChecked===true)
              {
                     console.log(DviewInfoList[i].PathName);
              }              
            } 
              */
        }
    }

    useEffect(() => {

        (async () => {
            try {
                const res = await gsb.post('/Report',
                    {   sb_data: {                           
                           
                        },
                        cPgmId: "CCASSMast",
                        cAction: "ListCCASS",
                    });
                setCCASSRptList(res.data.data)
                //console.log("ListCCASS.data.data", res.data.data);
             
             
               
            } catch (error) {
                utils.showError(error)
            }
        })()
    }, [gsb,s_reportID])


    useEffect(() => {
        //processListCCASSRptName in -> 
        (async () => {
            try {
                const res = await gsb.post('/Report',
                    {   sb_data: {                           
                           
                        },
                        cPgmId: "CCASSMast",
                        cAction: "ListDepartment",
                    });
                setdepartmentInfoList(res.data.data)
                console.log("setdepartmentInfoList: ", res.data.data)
               
            } catch (error) {
                utils.showError(error)
            }
        })()
    }, [gsb,s_reportID])

 
    useEffect(() => {
        (async () => {
            try {
                // get GsbFlag from SB.XBS
                const res = await gsb.post('/GsbFlag');
                //console.log("SmMastMain disp user_key: ", res.data.Flag.user_key)
                //console.log("SmMastMain disp data.Flag: ", res.data.Flag)
                GsbFlag = res.data.Flag;
                //console.log("SmMastMain disp GsbFlag: ", GsbFlag)
                //console.log("SmMastMain disp GsbFlag.lang: ", GsbFlag.lang)
                //console.log("SmMastMain disp GsbFlag.dateFormat: ", GsbFlag.dateFormat)
                console.log("GsbFlag.user_key: ", GsbFlag.user_key)        
                //console.log("GsbFlag.UserID: ", GsbFlag.UserID)
                //console.log("SmMastMain disp GsbFlag.CO_NAME: ", GsbFlag.CO_NAME)
                setCO_NAME( GsbFlag.CO_NAME) ;
                setcompanyLogoName( GsbFlag.companyLogoName) ;
                setSBPath( GsbFlag.SBPath) ;
                setTRAN_DATE(GsbFlag.TRAN_DATE ) ;
                setSETL_DATE(GsbFlag.SETL_DATE ) ;           
                if ( GsbFlag.isProduction == "Y" ) {
                    setcardOpen01("cardOpen01-Theme"+GsbFlag.DEF_THEME1);
                } else {
                    setcardOpen01("cardOpen01-Theme"+GsbFlag.DEF_THEME2);
                }
                setEnter2tab(GsbFlag.Enter2tab) ;
                setCSVFormat(GsbFlag.CSVFormat) ;
                setSUSPEND_AC( GsbFlag.SUSPEND_AC) ;
            } catch (error) {
                utils.showError(error)
            }
        })()
    }, [gsb])

    useEffect(() => {
        if ( Enter2tab == "Y" ) {
            let inputs = utils.PerformEnter2Tab()
        }
    }, []) 


    useEffect(() => {
        setRptName("")
        setShowRpt(false)
        setShowNoRecord(false)
        setShowOK(true)
        //console.log(s_Date1)
    }, [s_Date1,s_reportID,DataFormatValue])

    useEffect(() => {
        if ( RptName !== "" ) {
            document.getElementById("_rptlink")?.click()
            window.scrollTo(0, document.body.scrollHeight)
        }
    }, [RptName]) 

    const showErrorBox = (err: any) => {
        alert("Error:"+err.response.data.subSystem+" - "+err.response.data.description+", OS code:"+err.response.data.osCode)
    }

   	function highlightText(text: string, query: string) {
        let lastIndex = 0;
        const words = query
            .split(/\s+/)
            .filter(word => word.length > 0)
            .map(escapeRegExpChars);
        if (words.length === 0) {
            return [text];
        }
        const regexp = new RegExp(words.join("|"), "gi");
        const tokens: React.ReactNode[] = [];
        while (true) {
            const match = regexp.exec(text);
            if (!match) {
                break;
            }
            const length = match[0].length;
            const before = text.slice(lastIndex, regexp.lastIndex - length);
            if (before.length > 0) {
                tokens.push(before);
            }
            lastIndex = regexp.lastIndex;
            tokens.push(<strong key={lastIndex}>{match[0]}</strong>);
        }
        const rest = text.slice(lastIndex);
        if (rest.length > 0) {
            tokens.push(rest);
        }
        return tokens;
    }
    function escapeRegExpChars(text: string) {
        //return text.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, "\\$1");
        return text.replace(/([.*+?^=!:${}()|\\])/g, "\\$1");
    }
    const handleHotkey = (e: React.KeyboardEvent<HTMLFormElement>) => {
        //console.log(`ctrl:${e.ctrlKey} alt:${e.altKey} shift:${e.shiftKey} meta:${e.metaKey} key:${e.key} keyCode:${e.keyCode}`)

        // ctrl + s
        if (e.ctrlKey && e.keyCode === 83) {
            e.preventDefault()
            //handleSubmit(onSubmit)()
        }
    }


    const handleKeyDown = (event: React.KeyboardEvent<HTMLFormElement>) => {
        if (event.key === 'Enter') {
        event.preventDefault(); // Prevents default Enter key behavior (form submission)
        }
    };

    const handleSubmit = (event: React.FormEvent) => {
      event.preventDefault();
      const selectedItems = DviewInfoList.filter((item) => item.isChecked);
      console.log('Selected Items:', selectedItems);
      // You can now send selectedItems to an API or perform other actions
    };
    const CCASSListRenderer: ItemRenderer<CCASSRptINFO> = (CCASSRptList, { handleClick, modifiers, query }) => {
        if (!modifiers.matchesPredicate) {
            return null;
        }
        //const text = `${ac.acCode} - ${ac.acName1}`;
        const text = `${CCASSRptList.reportName}`;
        return (
            <MenuItem
                active={modifiers.active}
                disabled={modifiers.disabled}
                label={CCASSRptList.reportID}
                key={CCASSRptList.reportName}
                onClick={handleClick}
                text={highlightText(text, query)}
            />
        );
    };

    const CCASSListPredicate: ItemPredicate<CCASSRptINFO> = (query, CCASSList, _index, exactMatch) => {
        const normalizedText = `${CCASSList.reportName} - ${CCASSList.reportID}`.toLowerCase();
        
        const normalizedQuery = query.toLowerCase();

        if (exactMatch) {
            return normalizedText === normalizedQuery;
        } else {
            return normalizedText.indexOf(normalizedQuery) >= 0;
        }
    };

    const CCASSListValueRenderer = (CCASSList: CCASSRptINFO) => {
        return CCASSList.reportID
    }

    const DepartmentListRenderer: ItemRenderer<departmentINFO> = (setdepartmentInfoList, { handleClick, modifiers, query }) => {
        if (!modifiers.matchesPredicate) {
            return null;
        }
        //const text = `${ac.acCode} - ${ac.acName1}`;
        const text = `${setdepartmentInfoList.DepartmentName}`;
        return (
            <MenuItem
                active={modifiers.active}
                disabled={modifiers.disabled}
                //label={setdepartmentInfoList.DepartmentID}
                key={setdepartmentInfoList.DepartmentName}
                onClick={handleClick}
                text={highlightText(text, query)}
            />
        );
    };

    const DepartmenListPredicate: ItemPredicate<departmentINFO> = (query, departmentInfoList, _index, exactMatch) => {
        const normalizedText = "" //`${departmentInfoList.DepartmentName}`.toLowerCase();
        
        const normalizedQuery = query.toLowerCase();

        if (exactMatch) {
            return normalizedText === normalizedQuery;
        } else {
            return normalizedText.indexOf(normalizedQuery) >= 0;
        }
    };

    const DepartmenListValueRenderer = (departmentInfoList: departmentINFO) => {
        return departmentInfoList.DepartmentName
    }
    

    const showError = (err: any) => {
        if (err.response) {
            toaster.show({ message: err.response.data.description, intent: Intent.WARNING })
        } else if (err.request) {
            toaster.show({ message: "Request failed", intent: Intent.WARNING })
        } else {
            toaster.show({ message: err.message, intent: Intent.WARNING })
        }
    }

 


    const showSuccess = (message: string) => {
        toaster.show({ message: message, intent: Intent.SUCCESS })
    }

    function PageNo(n: number) {
        if (n > 0 ) {
            if ( nPage+n <= nTotalPage ) {
                setnPage(nPage+n)
            }
        } else
        {
            if ( nPage+n > 0 ) {
                setnPage(nPage+n)
            }
        }
        return null;
    }

    const [clickedButton, setClickedButton] = useState('');

    const buttonHandler = (event: React.MouseEvent<HTMLButtonElement>) => {
        event.preventDefault();
    
        const button: HTMLButtonElement = event.currentTarget;
        setClickedButton(button.name);
      };

     function setCCASSRpt1(text: string) {
         //return text.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, "\\$1");

         //setCountryIssuanceDesc("")
         //setCountryIssuance("")
         let CCASSRptItem = CCASSRptList.findIndex((CCASSRptItem: CCASSRptINFO) => CCASSRptItem.reportID === text)
         //   console.log("ClMastView JursidictionCountry1Desc.find text : ", text) 
    
        console.log("ClMastView JursidictionCountry1Desc.find CountryItem : ", CCASSRptItem) 
        console.log("ClMastView JursidictionCountry1Desc.find CountryItem.d_Country : ", CCASSRptList[CCASSRptItem]) 
         if ( CCASSRptItem== 0 || CCASSRptItem > 0) {
     
            sets_reportID(CCASSRptList[CCASSRptItem].reportID)
            setCCASSRptDesc(CCASSRptList[CCASSRptItem].reportName)
         }
 
         return setCCASSRpt1;
     }
 
    
    let Pagination = <>
        <div className="Row">
            <FormGroup className="Col-1-12" label="">
                { (nTotalPage > 1) && <a>Page</a>}
                { (nTotalPage > 1) &&
                    <Button minimal onClick={() =>PageNo(-1)}>&laquo;</Button>
                }
                { (nTotalPage > 1) && (nPage != 1) && 
                    <Button minimal onClick={() => setnPage(1)}>{1}</Button>
                }
                {aPageNumber.map((no, j) => 
                    (j+1 > nPage-10) && (j+1 < nPage) && (j+1 != 1) && <Button minimal onClick={() => setnPage(no.n)}>{no.n}</Button>
                )}
                { (nTotalPage >= 1) && <Button intent='primary'>{nPage}</Button> }
                {aPageNumber.map((no, j) => 
                    (j+1 > nPage) && (j+1 < nPage+10) && (j+1 != nTotalPage) && <Button minimal onClick={() => setnPage(no.n)}>{no.n}</Button>
                )}
                { (nTotalPage > 1) && (nPage != nTotalPage) && 
                    <Button minimal onClick={() => setnPage(nTotalPage)}>{nTotalPage}</Button>
                }
                { (nTotalPage > 1) &&
                    <Button minimal onClick={() =>PageNo(+1)}>&raquo;</Button>
                }
            </FormGroup>
        </div>
    </>

 
    let RptNameaRef = <>
        { RptNameNo > 0 && <div> Download / Print &nbsp;
            {aRptNameNo.map((no, j) => 
                <a target="_blank" rel="noopener noreferrer" href={`${gsb.defaults.baseURL}/Rptdownload?filename=${RptName}-${no.n}.pdf`}> <span id="RPageNo2" onClick={() => {} }> {no.n} &nbsp; </span> </a>
            )}
        </div> }
        { RptNameNo <= 0 && <a id="_rptlink" target="_blank" rel="noopener noreferrer" href={`${gsb.defaults.baseURL}/Rptdownload?filename=${RptName}`}>Download All / Print </a>}
        {/* RptName !== "" && AutoClickRptLink("_rptlink") */}
        <br></br><br></br>
    </>    

    let list = <>
        <div className="Spacing-V-16" />
        {/* {RptName.trim().length > 0 && <a target="_blank" rel="noopener noreferrer" href={`${gsb.defaults.baseURL}/Rptdownload?filename=${RptName}`}>Download / Print </a>} */}
        {RptName.trim().length > 0 && RptNameaRef}
        
    </>

    let list2 = <>
        <div className="Spacing-V-16" />       
        {ShowWait && <div>{imgWait}</div> }
        {nPage > 0 && Pagination}  Total No.: {countnumber}
        {/* display search list */}


        <div className="Spacing-V-16" />
                      <HTMLTable striped interactive condensed>
                    <thead>
                        <tr>
                           
                           {/* <th className="TCol-FileName">sr</th>*/}
                               <th>No.</th>
                             <th className="Tcol-ReportId">Report ID</th>   
                            <th className="TCol-FileName">File Name</th>
                            <th className="TCol-FileName">Report Name</th>    
                            {/*<th className="TCol-FileName">Report times</th>*/}
                            {/*<th className="Tcol-MTKCode">CCASS Type</th>*/}
                            <th className="Tcol-CCASSTYPE">Date</th>
                            <th className="Tcol-CCASSTYPE">Time</th>
                            {/*<th className="TCol-FileName">Date</th>*/}
                            {/*<th className="TCol-Records"><div className="Align-R">Size</div></th>*/}
                       
                            <th className="Tcol-ReportId"><input type = "checkbox" name="allselect"    onChange={hangedHandler} /></th>
                        </tr>
                    </thead>
                    <tbody>
                        {DviewInfoList.map((f, index) =>
                            <tr key={index}>
                                <td >{index+1}.</td>
                                <td className="TCol-ReportId">{f.reportId}</td>
                                <td className="TCol-FileName">{f.filename}</td>
                                <td className="TCol-ReportName">{f.reportName}</td>  
                                {/*<td className="TCol-ReportName">{f.times}</td> /} 
                                                              
                                {/*<td className="TCol-MTKCode">{f.StatementType}</td>*/}
                                <td className="TCol-DateTime">{f.date}</td>
                                <td className="TCol-DateTime">{f.time}</td>
                                {/*<td className="TCol-Records"><div className="Align-R">{utils.fileSize(f.size)}</div></td>*/}
                                {/*<td><AnchorButton icon={IconNames.DOWNLOAD} href={`${gsb.defaults.baseURL}/ViewPdf?fileName=${f.PathName}`}>Download</AnchorButton></td>*/}
                                {/*<td><AnchorButton icon={IconNames.DOWNLOAD} href={`${gsb.defaults.baseURL}/ViewPdf?fileName=${f.PathName}&inline`} target="_blank" >View</AnchorButton></td>*/}
                                <td>
                                     <input
                                        type="checkbox"
                                        id={f.reportId}
                                        name={f.filename}
                                       checked={f.isChecked}
                                         onChange={() => handleCheckboxChange(f.PathName)}
                                        />
                                </td>
                             </tr>
                        )}
                    </tbody>
                   
                </HTMLTable>

        {ShowWait && nTotalPage > 0 && <div>{imgWait}</div> }
        {nPage > 0 && Pagination}
    </>

      let list3 = <>
                <div className="Spacing-V-16" />
                <div className="Spacing-V-16" />
                <div className="Spacing-V-16" />
                      <HTMLTable striped interactive condensed>
                    <thead>
                        <tr>
                           
                           {/* <th className="TCol-FileName">sr</th>*/}
                               <th>No.</th>
                             <th className="Tcol-ReportId">Report ID</th>   
                            <th className="TCol-FileName">File Name</th>
                            <th className="TCol-FileName">Report Name</th>                            
                            <th className="TCol-FileName">Report times</th>                                                 
                            <th className="Tcol-CCASSTYPE">Date</th>
                            <th className="Tcol-CCASSTYPE">Time</th>
                            {/*<th className="TCol-FileName">Date</th>*/}
                            {/*<th className="TCol-Records"><div className="Align-R">Size</div></th>*/}
                       
                            {/*<th className="Tcol-ReportId"><input type = "checkbox" name="allselect"    onChange={hangedHandler} /></th>*/}
                        </tr>
                    </thead>
                    <tbody>
                        {VarInfoList.map((f, index) =>
                            <tr key={index}>
                                <td >{index+1}.</td>
                                <td className="TCol-ReportId">{f.reportId}</td>
                                <td className="TCol-FileName">{f.filename}</td>
                                <td className="TCol-ReportName">{f.reportName}</td>                                
                                <td className="TCol-ReportName">{f.times}</td>                                
                        
                                <td className="TCol-DateTime">{f.date}</td>
                                <td className="TCol-DateTime">{f.time}</td>
                                {/*<td className="TCol-Records"><div className="Align-R">{utils.fileSize(f.size)}</div></td>*/}
                                {/*<td><AnchorButton icon={IconNames.DOWNLOAD} href={`${gsb.defaults.baseURL}/ViewPdf?fileName=${f.PathName}&inline`}>View{f.cFNExt}</AnchorButton></td>*/}
                                <td><AnchorButton icon={IconNames.DOWNLOAD} href={`${gsb.defaults.baseURL}/ViewPdf?fileName=${f.PathName}`}>Dpwnload{f.cFNExt}</AnchorButton></td>
                           
                                {/*<td><AnchorButton icon={IconNames.DOWNLOAD} href={`${gsb.defaults.baseURL}/ViewPdf?fileName=${f.PathName}&inline`} target="_blank" >View</AnchorButton></td>*/}
                             
                             </tr>
                        )}
                    </tbody>
                   
                </HTMLTable>
      
      </>
    const onCCASSSelect_Print = () => {
        //console.log("onSBReindex fileInfoList", fileInfoList);
        setShowOK(false)
        ;
        
        (async () => {
            try {
                        
               //console.log("SysMaint res.data.s_Date1",s_Date1)
                setShowWait(true)
                setShowRpt(false)
                //setProgressValue(100)
                const res = await gsb.post('/Report',
                    {  sb_data: {      
                        s_Date1: s_Date1,        
                        s_StatementType:s_MTKCode,                        
                        s_DviewInfoList: DviewInfoList,   
                        s_DepartmentName:s_DepartmentName,                
                    },
                    cPgmId: "CCASSMast",
                    cAction: "CCASSSelect_Print",
                });   
                console.log(res)
                if ((res.data.RptName.length) > 0)
                {
                     console.log(res.data.data)
                    // setTaskList(res.data.data)
                // setShowTasks(true)
                    //setProgressValue(100)

                    setShowWait(false)
                    setShowNoRecord(false)
                    setShowRpt(true)
                    setRstdata(Rstdata2)
                
                    setRptHead1(res.data.Rpthead1)
                    setRptName(res.data.RptName)
                    setRptNameNo(res.data.RptNameNo)

                // console.log("RptName: ", RptName) 
                // console.log("RptNameNo: ", RptNameNo) 
                }
                else{                   
                
                    setRptName("")
                    setShowRpt(false)
                    setShowWait(false)
                }


            } catch (error) {
                console.log(error)
                utils.showError(error)
            }
        })()
    }
    const onCCASSSave = () => {
        //console.log("onSBReindex fileInfoList", fileInfoList);
        setShowOK(false)
        ;
        
        (async () => {
            try {
              
               //console.log("SysMaint res.data.s_Date1",s_Date1)
               
               // setShowRpt(false)
                //setProgressValue(100)
                const res = await gsb.post('/Report',
                    {  sb_data: {      
                        s_Date1: s_Date1,                                
                        s_DviewInfoList: DviewInfoList,
                        s_DepartmentName:s_DepartmentName,
                    },
                    cPgmId: "CCASSMast",
                    cAction: "CCASSSave",
                });   
              
               if ( res.data.count > 0 ) {
   					console.log(res.data.CSVfile)
                    showSuccess("Saving CCASS list Setting is done.("+ res.data.CSVfile + ")!!")
                    setShowWait(false)
                    setShowNoRecord(false)
                    setShowRpt(true)              
                    
                }
                //setRptHead1(res.data.Rpthead1)
            
                 //console.log(res.data.data)


            } catch (error) {
                console.log(error)
                utils.showError(error)
            }
        })()
    }

 
    const onSubmit = async (e: FormEvent) => {
        e.preventDefault()
        setShowWait(true)
        setShowOK(false)
        //setShowWait(true)
        setShowNoRecord(false)
        setShowRpt(false)
        setRstdata([])
        setRptHead1("")
        setRptName("")
        setRptLogName("")

        ProgressId2 = utils.genUUID()
        setProgressId(ProgressId2)
        setProgressValue(0)

        let m_limit = searchLimit
        if ( selectedTabId === "detail" ) {
            m_limit = 1
        }

        if ( utils.getDeviceType()) {
            setMoblieDev(true)
        } else {
            setMoblieDev(false)
        }
        try {
            if ( m_limit > 1 ) {
                const res = await gsb.post('/Report',
                {   sb_data: {
                        ProgressId: ProgressId2,
                        s_Date1: s_Date1,
                        s_reportID:s_reportID,                     
                        s_MTKCode: s_MTKCode, 
                        nPage: 1,
                        backward: false,
                        s_DepartmentName:s_DepartmentName,   
                    },
                    cPgmId: "CCASSMast",
                    cAction: "CCASSList",
                });
                //count CCASS Report
                setcountnumber(Object.keys(res.data.data).length)
                //count VAR Report
  				setcountnumberData2(Object.keys(res.data.data2).length)

                //console.log(countnumber)
                // console.log(res.data.data2)

                setVarInfoList(res.data.data2)
                setDviewInfoList(res.data.data)

               // var  limit =searchLimit;
  
                var count = Object.keys(res.data.data).length
                //console.log(count)
               
                if (count > 0) {
                    const aPageNumber1 = []

                    //setnTotalPage(Math.ceil(count / searchLimit))
                   //for ( let j = 1; j <= Math.ceil(count/searchLimit); j++ ) {
                    //    aPageNumber1.push({n: j});
                    //}
                    //setaPageNumber(aPageNumber1)
                   // setnPage(1)
                 
                    setShowWait(false)
                    setShowNoRecord(false)
                 //   setShowRpt(true)
                   // setRstdata(Rstdata2)
                     console.log("Rstdata: ", res.data.RptLogName) 
                 //   setRptHead1(res.data.Rpthead1)
                 //   setRptName(res.data.RptName)
                  
                 //   setRptNameNo(res.data.RptNameNo)
                    setRptLogName(res.data.RptLogName)
                    setRptNameNo(res.data.RptNameNo)
                    setErrCount(res.data.ErrCount)

                    if (res.data.ErrCount > 0)
                    {
                        utils.showError("It has "+ res.data.ErrCount + " error(s) founds in log file")
                    }
                }
                else
                {
                    setShowNoRecord(true)
                     
                }
                   
            } else {

            }
            setShowWait(false)
            setnPage(1)

        }catch (error) {
            setShowWait(false)
            utils.showError(error)
        }
  
    }
       //Press page No 1 2 3 4
       /*
       useEffect(() => {
        if ( nPage > 0 && nPage <= nTotalPage && selectedTabId == "list" ) {
    
            setShowWait(true)
            if ( nPage > 0 ) {
                //setcPrintMode("S")
            } 
    
            (async () => {
                try {
                    //console.log("IntRMastMain useEffect nPage > 0  ", nPage)
                    const res = await gsb.post('/Report',
                    {   sb_data: {
                            ProgressId: ProgressId2,                           
                            s_Date1: s_Date1,     
                            s_reportID:s_reportID,                     
                            s_MTKCode: s_MTKCode,                          
                            sbbatch : "N",
                            nPage: nPage,
                            limit: searchLimit,
                            backward: false,
                           s_DepartmentName:s_DepartmentName,   
                        },
                    cPgmId: "CCASSMast",
                    cAction: "CCASSList",
                    });

                    setVarInfoList(res.data.dat2)
                    setDviewInfoList(res.data.data)
                    //console.log("nPage1")
                    setShowWait(false)
        
                } catch (error) {
                    utils.showError(error)
                }
            })()
        }
    }, [gsb,s_Date1 , s_reportID])*/

    const handleButtonClick = () => {
            alert('Floating button clicked!');
            // Add your desired logic here, e.g., scrolling to top
        };


    const [AddDepart, setAddDepart] = useState(false)
    
 
    const [CCASSFileNamesuffix,setCCASSFileNamesuffix] = useState("")

    const handleClick = () => {
         window.open(`${gsb.defaults.baseURL}/logdownload?filename=${RptLogName}&inline`, '_blank', 'noopener,noreferrer');
     //   window.location.href = `${gsb.defaults.baseURL}/logdownload?filename=${RptLogName}&inline`; // Replace with your desired URL
    };

    let CoHead = <SystemHeader companyLogo={companyLogoName} companyName={CO_NAME} dataPath={SBPath} tradeDate={TRAN_DATE} settlementDate={SETL_DATE}></SystemHeader>
    return (
        <>

    <form onSubmit={onSubmit} onKeyDown={handleKeyDown}>
        <div className="Spacing-V-Menu"></div>
        <div className="Row">
                <FormGroup className="Col-1-12"  >
                    {CoHead}
                </FormGroup>
            </div>
            <Card className={cardOpen01} interactive={false} elevation={Elevation.THREE} >
                <H3>CCASS Report</H3>
                
                <div className="Spacing-V-16" /> 
                <div className="Row">
                    <FormGroup className="Col-1-2" label="Start Date" labelFor="inputs_Date1">
                        {/* <InputGroup id="inputs_Date1" name="s_Date1" value={s_Date1} type="date" placeholder="YYYY-MM-DD" leftIcon="calendar" /> */}
                        <InputGroup id="inputs_Date1" type="date" placeholder="YYYY-MM-DD" leftIcon="calendar" onChange={utils.handleStringChange(s =>{ sets_Date1(s)}) } />
                    </FormGroup>   
                </div>                     
                <div className="Row">
                    <FormGroup className="Col-1-2" label="Select Show option by Depart" labelFor=""> 
                        <Suggest
                            defaultSelectedItem={departmentInfoList.find((aj) => aj.DepartmentID === 1)}
                            inputProps={{ placeholder: "Please choose Depart" }}                                
                            items={departmentInfoList}
                            itemRenderer={DepartmentListRenderer}
                            itemPredicate={DepartmenListPredicate}
                            inputValueRenderer={DepartmenListValueRenderer}                  
                            //onItemSelect={(aj) => {sets_DepartmentName (aj.DepartmentName)}}         
                            onItemSelect={(aj) => { setValue("DepartmentName", aj.DepartmentName);sets_DepartmentName(aj.DepartmentName)}}      
                                         
                        />
                    </FormGroup>       
                      <FormGroup className="Col-3-2" label= {"\u00A0"} labelFor="*">          
                    {  <Button className="Col-1-2" icon="document" onClick={() => { setAddDepart(true) } } >Add Department</Button> }
                        <Dialog
                            icon={IconNames.EDIT} 
                            title = "Add Department"
                            isOpen={AddDepart}
                            onClose={ () => { setAddDepart(false) } }
                            style={{ minWidth: '90.0%' , minHeight: '100.0%' }}
                        >
                            {<DialogBody>
                            <CCassAddDeptMain gsb={gsb}></CCassAddDeptMain>
                            </DialogBody>}
                    </Dialog>
                    </FormGroup>    
                </div>          
                      
                <div className="Row">
                    {/*<Button  className="Col-1-1"  icon="add"  onClick={onCCASSSave}>Add</Button>*/}
                    {/* <Button className="Col-1-1" icon="add" onClick={() => { setCurrentMode("new"); setSelectedTabId("detail") }}>New</Button> */}



                </div>   
                 <div className="Spacing-V-16" />        
                <div className="Row">
                   
                    <FormGroup style={{justifyContent: 'flex-end'}} className="Col3-1-10" label={t('Report ID')} labelFor="inputd_ReportID">
                            <Suggest
                                inputProps={{ placeholder: "Please choose Report ID" }}                                
                                items={CCASSRptList}
                                itemRenderer={CCASSListRenderer}
                                itemPredicate={CCASSListPredicate}
                                inputValueRenderer={CCASSListValueRenderer}                  
                                onItemSelect={(aj) => {sets_reportID (aj.reportID);setCCASSRpt1(aj.reportID)}}
                            />
                            {/*errors.d_Country_Issuance && errors.d_Country_Issuance.types && <span id="Err_msg">{errors.d_Country_Issuance.types.message}</span>*/}
                            <div>
                            <div id="DispText">{CCASSRptDesc}</div>
                            </div>
                        </FormGroup> 
                     
                    <FormGroup className="Col-1-6" label="SELECT CCASS TYPE">
                        <RadioGroup
                            inline={true}
                            selectedValue={s_MTKCode}
                            onChange={utils.handleStringChange(s => sets_MTKCode(s)) }
                        >
                            <Radio label="ALL"  value="ALL"/>
                            <Radio label="HKMK"  value="HKMK"/>
                            <Radio label="GLOB"  value="GLOB"/>     
                            <Radio label="MAMK"  value="MAMK"/>          
                            <Radio label="SZMK"  value="SZMK"/>   
                            <Radio label= "VAR" value ="VAR"/>
                                                                                              
                        </RadioGroup>
                    </FormGroup> 
                </div>
                <div className ="Row">
                    <div className="Col-1-3">Generate Report List</div>
                </div>               
                <div className="Spacing-V-16" />
                <div className="Row">
                    <Button    className="Col-1-1" type="submit">OK</Button>
                </div>  
                {RptLogName.trim().length > 0 && <div className="Spacing-V-16" />}
               {RptLogName.trim().length > 0 && <a className="Col-2-1"   target="_blank" rel="noopener noreferrer" href={`${gsb.defaults.baseURL}/logdownload?filename=${RptLogName}&inline`}>View Log</a>}
               {RptLogName.trim().length > 0 && ErrCount > 0 && <div className="Row" >
                    <div className="Spacing-V-16" />
                    <div className="Col-1-2"  >
                        Error: {ErrCount} file(s) error found
                    </div>
                </div> 
                }

                {ShowRpt && list} 
                 
                { countnumber > 0 && list2}
                <div className="Row">
                     {countnumber > 0 && list2 && DviewInfoList.length > 0 && <Button className="Col-1-2" icon={IconNames.PRINT} onClick={onCCASSSelect_Print}>Print CCASS Report</Button>}
                     { countnumber > 0 && list2 && DviewInfoList.length > 0 && <Button className="Col-3-2" icon={IconNames.SETTINGS}  onClick={onCCASSSave}>Save CCASS setting</Button>}
                </div>
                {/* {ShowWait && <div>{imgWait}</div> } */}
                 { ShowWait && <div className="TCol-Progress2">Progress ...</div> }
                 { ShowWait && <div className="TCol-Progress2"><ProgressBar stripes={false} animate={true} value={ProgressValue} /></div> }
                 {/* countnumber > 0 && list2 && ShowNoRecord && <p>*/}
                    {countnumber == 0 && countnumberData2 ==0 && ShowNoRecord && <p>
                    <div className="Spacing-V-16" />
                    <div className="Row">
                        <FormGroup className="Col-1-3"  >
                            <span id="Err_msg">No Record found !!!</span>
                        </FormGroup>
                    </div>
                </p>
                }
                {(s_MTKCode =="VAR" ) &&  list3}
                 </Card>                
                {ShowRpt && list}
                {<Button  className="Col-1-2"  style = {utils.buttonStyle(120)}  type="submit">Generate Report List</Button>}
                {countnumber > 0 && list2 && DviewInfoList.length > 0 && <Button   className="Col-1-2" style = {utils.buttonStyle(170)} icon={IconNames.PRINT} onClick={onCCASSSelect_Print}>Print CCASS Report</Button>}
                {countnumber > 0 && list2 && DviewInfoList.length > 0 && <Button className="Col-3-2" style = {utils.buttonStyle(220)} icon={IconNames.SETTINGS}  onClick={onCCASSSave}>Save CCASS setting</Button>}

               {RptLogName.trim().length > 0 && <a target="_blank" rel="noopener noreferrer" href={`${gsb.defaults.baseURL}/logdownload?filename=${RptLogName}&inline`}>View Log</a>}
 
                { ErrCount > 0  && <Button className="Col-3-2" intent="warning" style = {utils.buttonStyle(270)} icon={IconNames.RECORD}  onClick={handleClick}>logs</Button>}  
                { ErrCount === 0  && countnumber > 0 && <Button className="Col-3-2" intent="success" style = {utils.buttonStyle(270)} icon={IconNames.RECORD}  onClick={handleClick}>logs</Button>}  
           </form>
        </>
    );
}
export default CCASSRptMain